module.exports = __webpack_public_path__ + "img/about-5.0b6ed3e8.png";